import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { InputConfig, InputType } from '../../../model';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'ui-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordComponent implements OnInit {

  /**
   * * Título do Input.
   */
  @Input() title: string = '';
  /**
   * * Configuração para montar o input.
   */
  @Input() input: InputConfig = {type: InputType.text};
  /**
   * * Input inválido.
   */
  @Input() invalid: boolean = false;

  /**
   * * Form Control para o input.
   */
  @Input() formControl!: FormControl;

  showPassword = false;

  constructor() { }

  ngOnInit(): void {
  }

  toggleShow() {
    this.showPassword = !this.showPassword;
    this.input.type = this.showPassword ? InputType.text : InputType.password;
  }

}
